import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const dTfieldsSlice = createSlice({
  name: "dTFields",
  initialState,
  reducers: {
    fetchDTFieldsStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    fetchDTFieldsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchDTFieldsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const {
  fetchDTFieldsStart,
  fetchDTFieldsSuccess,
  fetchDTFieldsFailure,
} = dTfieldsSlice.actions;
export default dTfieldsSlice.reducer;
